import { head } from "lodash";
import React from "react";
import { Tooltip } from "reactstrap";
import "./styles.scss"

const DocsTooltip = ({ placement, isOpen, targetId, toggle, content, linkText, link, multipleLinks }) => {
  return(
    <React.Fragment>
        <Tooltip
          className= "tooltip-component"
          placement={placement}
          isOpen={isOpen}
          target={targetId}
          toggle={toggle}
          autohide={false}
          style={{
            border: "2px solid #3d384d",
            borderRadius: "5px",
            backgroundColor: "#1e192e",
            zIndex: 1,
            opacity:1,
            maxWidth: `${multipleLinks ? '600px' : '300px'}`,
            pointerEvents:'none',
          }}
        > 
        <div className={`d-flex ${multipleLinks ? 'flex-column align-items-start gap-1' : 'align-items-center gap-1'} font-size-12`}>
        <span>{content || 'Need help?'} </span>
        <div className={`${multipleLinks ? 'd-flex gap-2' : ''}`}>
            {multipleLinks ? (multipleLinks.map((item, index)=>(
              <a key={index} className="d-flex align-items-center text-decoration-underline" style={{color:"#7e52e2"}} rel="noreferrer" href={item.link} target="_blank">   
                <span><b>{item.linkText}</b></span>   
              </a>
         ))) :
            <a className="d-flex align-items-center gap-1" style={{color:"#7e52e2"}} rel="noreferrer" href={link} target="_blank">   
              <span><b>{linkText}</b></span>   
            <i className="bx bx-link-external font-size-12"></i> </a>
         } 
         </div>
        
        </div>
      </Tooltip>
    </React.Fragment>
  )
}

export default DocsTooltip;